module.exports = __webpack_public_path__ + "img/result-1H.3479effb.png";